module.exports = __webpack_public_path__ + "img/thumbnail-square.b41dfe6.svg";